import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerProductsPage from "../pages/DsokCustomerProductsPage";

export const dsokCustomerProductsRoute = {
  path: "/dsok/customer-detail/:customerUrl/products",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerProductsPage} />
    </DsokCustomerDetailProvider>
  ),
};
